import { render, staticRenderFns } from "./newContractManageList.vue?vue&type=template&id=58b67a09&scoped=true"
import script from "./newContractManageList.vue?vue&type=script&lang=js"
export * from "./newContractManageList.vue?vue&type=script&lang=js"
import style0 from "./newContractManageList.vue?vue&type=style&index=0&id=58b67a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b67a09",
  null
  
)

export default component.exports